import React, { Fragment } from "react";
import PropTypes from "prop-types";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import "./styles.css";

const LightboxComponent = (props) => {
  return (
    <Fragment>
      {props.isOpen && (
        <Lightbox
          mainSrc={
            props.imgLightbox[
              props.lightOpenPosicion > 0 ? props.lightOpenPosicion - 1 : 0
            ].imagen
          }
          onCloseRequest={() => props.lightbox()}
        />
      )}
    </Fragment>
  );
};

LightboxComponent.propTypes = {
  imgLightbox: PropTypes.array,
  isOpen: PropTypes.bool,
  lightbox: PropTypes.func,
  lightOpenPosicion: PropTypes.number,
};

export default LightboxComponent;
